export default {
  containerVisitas: {
    semVisitas: 'No hay visitas en 14 días',
    visitasAgendadas: 'Visitas programadas',
    visitasRealizadas: 'Visitas realizadas'
  }
};
